import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import { height } from '../header/styles';
import { H4Text } from '@prisjakt/ui/text/variants';

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${layout.pageContent.maxWidth.rem};
  margin: 0 auto;
`;

export const Inner = styled.div`
  position: absolute;
  max-width: ${layout.pageContent.maxWidth.rem};
  width: 100%;

  ${media.smallOnly`
    scroll-behavior: smooth;
    overflow: auto;
    position: fixed;
    top: ${height.mobileWithSearch};
    bottom: 0;
    background: white;
    padding: ${layout.measurements.spacingSmall} 0;
  `}
`;

export const Suggestions = styled.ul`
  width: 48.5%;
  margin: 0 auto;
  padding: ${layout.measurements.spacingSmall} 0
    ${layout.measurements.spacingSmall};
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 4px;
  list-style: none;
  z-index: 1;
  margin-top: -${layout.measurements.spacingSmall};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);

  ${media.mediumOnly`
    position: relative;
    left: 32%;  
    width: 50%;
    margin: 0;
  `};

  ${media.smallOnly`
    border: none;
    overflow: auto;
    border-radius: none;
    width: 100%;
    min-height: 100%;
  `}
`;

export const PopularSearchesTitle = styled(H4Text)`
  margin-left: ${layout.measurements.spacingNormal};
  margin-top: ${layout.measurements.spacingNormal};
  flex: 0 1 auto;
`;

export const AdItem = styled.li``;
